var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: { "offset-y": "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        icon: "",
                        "aria-label":
                          "Alterar tema. Tema atual: " + _vm.currentThemeLabel,
                        "aria-haspopup": "menu",
                      },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("v-icon", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v(_vm._s(_vm.currentThemeIcon)),
                  ]),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-list",
        {
          attrs: { role: "menu", "aria-label": "Selecione um tema", dense: "" },
        },
        _vm._l(_vm.themes, function (theme) {
          return _c(
            "v-list-item",
            {
              key: theme.value,
              attrs: {
                role: "menuitemradio",
                "aria-checked":
                  _vm.currentTheme === theme.value ? "true" : "false",
              },
              on: {
                click: function ($event) {
                  return _vm.selectTheme(theme.value)
                },
              },
            },
            [
              _c(
                "v-list-item-icon",
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        color:
                          _vm.currentTheme === theme.value ? "primary" : "",
                        "aria-hidden": "true",
                      },
                    },
                    [_vm._v(" " + _vm._s(theme.icon) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v(_vm._s(theme.label))]),
                  theme.description
                    ? _c("v-list-item-subtitle", [
                        _vm._v(" " + _vm._s(theme.description) + " "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm.currentTheme === theme.value
                ? _c(
                    "v-list-item-action",
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            small: "",
                            color: "primary",
                            "aria-hidden": "true",
                          },
                        },
                        [_vm._v("mdi-check")]
                      ),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Selecionado"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }